export const DEFAULT_LOBBY_SETTINGS_TAB = "map-pool";

export const LOBBY_SETTINGS_TABS = [
    { id: "map-pool", label: "Map pool" },
    { id: "server-locations", label: "Server locations" },
    { id: "match-filters", label: "Match filters" },
];

export const LOBBY_SETTINGS_TAB_IDS = LOBBY_SETTINGS_TABS.map((tab) => tab.id);

export function resolveLobbySettingsTab(tabId) {
    if (LOBBY_SETTINGS_TAB_IDS.includes(tabId)) {
        return tabId;
    }
    return DEFAULT_LOBBY_SETTINGS_TAB;
}
